import React from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import { Checkbox, Icon } from "../../common/";
import Helper from "../../../helper/Helper";
import DisputesRow from "./disputesRow/DisputesRow";
import DisputesRowBox from "./disputesRowBox/DisputesRowBox";
import styles from "../../orders/orderTable/OrderTable.scss";

const ProductTable = props => {
  const {
    browser,
    data,
    searchString,
    toggleCheckbox,
    seller,
    selectedItems,
    onQtyChange,
    dropdown,
    status,
    onUpdateQty
  } = props;

  const property = Helper.validator(data);

  const rows =
    data && !_.isEmpty(data)
      ? data.map((item, index) => {
          return (
            <DisputesRow
              item={item}
              property={property}
              searchString={searchString}
              seller={seller}
              key={index}
            />
          );
        })
      : "";

  const box =
    data && !_.isEmpty(data)
      ? data.map((item, index) => (
          <DisputesRowBox
            item={item}
            property={property}
            searchString={searchString}
            toggleCheckbox={toggleCheckbox}
            seller={seller}
            onQtyChange={onQtyChange}
            selectedItems={selectedItems}
            key={index}
            dropdown={dropdown}
            status={status}
            onUpdateQty={onUpdateQty}
          />
        ))
      : "";

  const dir = props.dir && props.dir === "asc" ? "desc" : "asc";

  return (
    <div className={styles.ctr}>
      {browser && browser.greaterThan.tablet ? (
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              {property.haveVal("ticket_nr") ? (
                <th>{I18n.getText("disputes.ticket-nr")}</th>
              ) : (
                ""
              )}
              {property.haveVal("dispute_type")? (
                <th>{I18n.getText("disputes.dispute-type")}</th>
              ) : (
                ""
              )}
              {property.haveVal("ref_to") ? (
                <th>{I18n.getText("disputes.doc-nr")}</th>
              ) : (
                ""
              )}
              {property.haveVal("created_at") ? (
                <th>{I18n.getText("statement-details.order-view-created")}</th>
              ) : (
                ""
              )}
              {property.haveVal("dispute_reason") ? (
                <th>{I18n.getText("disputes.reason")}</th>
              ) : (
                ""
              )}
              {property.haveVal("closed_at") ? (
                <th>{I18n.getText("transfers.closed-at")}</th>
              ) : (
                ""
              )}
              {property.haveVal("status") ? (
                <th>{I18n.getText("imports.status")}</th>
              ) : (
                ""
              )}
              <th>{I18n.getText("disputes.paid")}</th>
              <th />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      ) : (
        box
      )}
    </div>
  );
};

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/disputes/disputesTable/DisputesTable.js